import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

/**
 * @returns {boolean}
 */
export const useEnablePurchaseOrderCsvImport = () => useFeatureFlag(FeatureFlagDeclarations.enablePurchaseOrderCsvImport);
